/**
 * Mock Data: Programs
 * Static dataset for programs UI layout.
 */

import type { ProgramItem } from "../domain/model/ProgramsModel";

export type ProgramsResponse = {
  readonly data: readonly ProgramItem[];
};

export const mockProgramsData: ProgramsResponse = {
  data: [
    {
      id: "1",
      programId: "FEN28432",
      name: "Promo Natal dan Tahun Baru 2026",
      programName: "Promo Natal dan Tahun Baru 2026",
      status: "not_started",
      startDate: "1 Nov 2025",
      endDate: "31 Dec 2025",
      incentiveType: "Point Multiplier",
      basedOn: "Transaction Amount",
      totalProducts: 150,
      totalCustomers: 1200,
      createdAt: "2025-10-01T10:00:00Z",
      actions: {
        canEdit: true,
        canDelete: true,
        canActivate: true,
      },
    },
    {
      id: "2",
      programId: "FEN28432",
      name: "Promo Natal dan Tahun Baru 2026",
      programName: "Promo Natal dan Tahun Baru 2026",
      status: "ongoing",
      startDate: "1 Nov 2025",
      endDate: "31 Dec 2025",
      incentiveType: "Point Multiplier",
      basedOn: "Transaction Amount",
      totalProducts: 150,
      totalCustomers: 1200,
      createdAt: "2025-10-01T10:00:00Z",
      actions: {
        canEdit: true,
        canDelete: false,
        canActivate: false,
      },
    },
    {
      id: "3",
      programId: "FEN28432",
      name: "Promo Natal dan Tahun Baru 2026",
      programName: "Promo Natal dan Tahun Baru 2026",
      status: "ongoing",
      startDate: "1 Nov 2025",
      endDate: "31 Dec 2025",
      incentiveType: "Point Multiplier",
      basedOn: "Transaction Amount",
      totalProducts: 150,
      totalCustomers: 1200,
      createdAt: "2025-10-01T10:00:00Z",
      actions: {
        canEdit: true,
        canDelete: false,
        canActivate: false,
      },
    },
    {
      id: "4",
      programId: "FEN28432",
      name: "Promo Natal dan Tahun Baru 2026",
      programName: "Promo Natal dan Tahun Baru 2026",
      status: "ongoing",
      startDate: "1 Nov 2025",
      endDate: "31 Dec 2025",
      incentiveType: "Point Multiplier",
      basedOn: "Transaction Amount",
      totalProducts: 150,
      totalCustomers: 1200,
      createdAt: "2025-10-01T10:00:00Z",
      actions: {
        canEdit: true,
        canDelete: false,
        canActivate: false,
      },
    },
    {
      id: "5",
      programId: "FEN28432",
      name: "Promo Natal dan Tahun Baru 2026",
      programName: "Promo Natal dan Tahun Baru 2026",
      status: "ended",
      startDate: "1 Nov 2025",
      endDate: "31 Dec 2025",
      incentiveType: "Point Multiplier",
      basedOn: "Transaction Amount",
      totalProducts: 150,
      totalCustomers: 1200,
      createdAt: "2025-10-01T10:00:00Z",
      actions: {
        canEdit: false,
        canDelete: false,
        canActivate: false,
      },
    },
    {
      id: "6",
      programId: "FEN28432",
      name: "Promo Natal dan Tahun Baru 2026",
      programName: "Promo Natal dan Tahun Baru 2026",
      status: "ended",
      startDate: "1 Nov 2025",
      endDate: "31 Dec 2025",
      incentiveType: "Point Multiplier",
      basedOn: "Transaction Amount",
      totalProducts: 150,
      totalCustomers: 1200,
      createdAt: "2025-10-01T10:00:00Z",
      actions: {
        canEdit: false,
        canDelete: false,
        canActivate: false,
      },
    },
    {
      id: "7",
      programId: "FEN28432",
      name: "Promo Natal dan Tahun Baru 2026",
      programName: "Promo Natal dan Tahun Baru 2026",
      status: "ended",
      startDate: "1 Nov 2025",
      endDate: "31 Dec 2025",
      incentiveType: "Point Multiplier",
      basedOn: "Transaction Amount",
      totalProducts: 150,
      totalCustomers: 1200,
      createdAt: "2025-10-01T10:00:00Z",
      actions: {
        canEdit: false,
        canDelete: false,
        canActivate: false,
      },
    },
    {
      id: "8",
      programId: "FEN28432",
      name: "Promo Natal dan Tahun Baru 2026",
      programName: "Promo Natal dan Tahun Baru 2026",
      status: "ended",
      startDate: "1 Nov 2025",
      endDate: "31 Dec 2025",
      incentiveType: "Point Multiplier",
      basedOn: "Transaction Amount",
      totalProducts: 150,
      totalCustomers: 1200,
      createdAt: "2025-10-01T10:00:00Z",
      actions: {
        canEdit: false,
        canDelete: false,
        canActivate: false,
      },
    },
  ],
};

